import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { withValueCap } from 'pages/globals/global';
import InputLabel from 'components/InputLabel/index';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import constantFormValues from '../utils/formInputNames';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import HistoryModalContainer from 'components/modal/HistoryModalContainer';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter } from '@mui/material';

dayjs.extend(utc);

const LeaseHistoryDetailModal = ({ setDetailType, detailType, setSelectHistory, selectHistory, showModal, setShowModal }) => {
	const [form] = Form.useForm();

	const [screenSize, setScreenSize] = useState('md');
	const [advanceAmount, setAdvanceAmount] = useState(0);
	const [advanceAmount_new, setAdvanceAmount_new] = useState(0);

	const handleClose = () => {
		setShowModal(false);
		setDetailType(null);
		setSelectHistory(null);
	};

	useEffect(() => {
		if (selectHistory) {
			setAdvanceAmount(selectHistory?.[0]?.advanceAmount);
			setAdvanceAmount_new(selectHistory?.[1]?.advanceAmount);

			const viewValues = {
				leaseType: selectHistory?.[0]?.leaseType,

				leaseTitle: selectHistory?.[0]?.leaseTitle,
				leaseTitle_new: selectHistory?.[1]?.leaseTitle,

				initialDiscountRate: selectHistory?.[0]?.initialDiscountRate,
				initialDiscountRate_new: selectHistory?.[1]?.initialDiscountRate,

				paymentModality: selectHistory?.[0]?.paymentModality,
				paymentModality_new: selectHistory?.[1]?.paymentModality,

				paymentFrequency: selectHistory?.[0]?.paymentFrequency,
				paymentFrequency_new: selectHistory?.[1]?.paymentFrequency,

				grossRentList: selectHistory?.[0]?.grossRentList,
				grossRentList_new: selectHistory?.[1]?.grossRentList,

				advanceAmountList: selectHistory?.[0]?.advanceAmountList,
				advanceAmountList_new: selectHistory?.[1]?.advanceAmountList,

				effectiveDate: dayjs(selectHistory?.[0]?.changes?.[selectHistory?.[0]?.changes?.length - 1]?.inputChangeEffectiveDate),
				effectiveDate_new: dayjs(selectHistory?.[1]?.changes?.[selectHistory?.[1]?.changes?.length - 1]?.inputChangeEffectiveDate),

				inputChangeLeaseTerm: selectHistory?.[0]?.changes?.[selectHistory?.[0]?.changes?.length - 1]?.inputChangeLeaseTerm,
				inputChangeLeaseTerm_new: selectHistory?.[1]?.changes?.[selectHistory?.[1]?.changes?.length - 1]?.inputChangeLeaseTerm,

				upfrontLeasePayment: selectHistory?.[0]?.upfrontLeasePayment,
				upfrontLeasePayment_new: selectHistory?.[1]?.upfrontLeasePayment,

				initialDirectCost: selectHistory?.[0]?.initialDirectCost,
				initialDirectCost_new: selectHistory?.[1]?.initialDirectCost,

				securityDeposit: selectHistory?.[0]?.securityDeposit,
				securityDeposit_new: selectHistory?.[1]?.securityDeposit,

				cashIncentiveAmount: selectHistory?.[0]?.cashIncentiveAmount,
				cashIncentiveAmount_new: selectHistory?.[1]?.cashIncentiveAmount,
			};

			form.setFieldsValue(viewValues);
		}
	}, [selectHistory]);

	return (
		<HistoryModalContainer
			icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
			showModal={showModal}
			screenSize={screenSize}
			handleClose={handleClose}
			title="Lease History Detail"
			setScreenSize={setScreenSize}
		>
			<Form form={form} style={{ margin: '20px 50px', marginBottom: '0px' }}>
				<Row gutter={[16, 0]}>
					<Col xs={24} md={6}>
						<InputLabel label="Label" head={true} />
					</Col>
					<Col xs={24} md={9}>
						<InputLabel label="Pervious Data" head={true} />
					</Col>
					<Col xs={24} md={9}>
						<InputLabel label={`${detailType === 'edit' ? 'Edited Data' : 'Modified Data'}`} head={true} />
					</Col>

					<Col xs={24} md={6}>
						<InputLabel label={constantFormValues?.leaseTitle?.label} head={true} />
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name={constantFormValues?.leaseTitle?.key}>
							<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
						</Form.Item>
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name={`${constantFormValues?.leaseTitle?.key}_new`}>
							<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
						</Form.Item>
					</Col>

					<Col xs={24}>
						<Form.Item
							shouldUpdate={(previousValue, currentValue) =>
								previousValue?.[constantFormValues?.leaseType?.key] !== currentValue?.[constantFormValues?.leaseType?.key]
							}
							noStyle
						>
							{({ getFieldValue }) => {
								if (getFieldValue(constantFormValues?.leaseType?.key) === 'Finance Lease') {
									return (
										<Row gutter={[16, 0]}>
											<Col xs={24} md={6}>
												<InputLabel label={constantFormValues?.initialDiscountRate?.label} head={true} />
											</Col>

											<Col xs={24} md={9}>
												<Form.Item
													name={constantFormValues?.initialDiscountRate?.key}
													rules={constantFormValues?.initialDiscountRate?.rules}
												>
													<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
												</Form.Item>
											</Col>

											<Col xs={24} md={9}>
												<Form.Item
													rules={constantFormValues?.initialDiscountRate?.rules}
													name={`${constantFormValues?.initialDiscountRate?.key}_new`}
												>
													<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
												</Form.Item>
											</Col>
										</Row>
									);
								} else {
									return <Form.Item name={constantFormValues?.initialDiscountRate?.key} noStyle />;
								}
							}}
						</Form.Item>
					</Col>

					<Col xs={24} md={6}>
						<InputLabel label="Effective Date" head={true} />
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name="effectiveDate">
							<DatePicker disabled format="YYYY-MM-DD" className="antd-datePicker" style={{ width: '100%', height: '32px' }} />
						</Form.Item>
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name="effectiveDate_new">
							<DatePicker disabled format="YYYY-MM-DD" className="antd-datePicker" style={{ width: '100%', height: '32px' }} />
						</Form.Item>
					</Col>

					<Col xs={24} md={6}>
						<InputLabel label={constantFormValues?.paymentFrequency?.label} head={true} />
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name={`${constantFormValues?.paymentFrequency?.key}`}>
							<Select
								disabled
								showSearch
								filterOption={true}
								optionFilterProp="children"
								placeholder="Select from the list"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							>
								{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
									<Select.Option key={key} value={value}>
										{label}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name={`${constantFormValues?.paymentFrequency?.key}_new`}>
							<Select
								disabled
								showSearch
								filterOption={true}
								optionFilterProp="children"
								placeholder="Select from the list"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							>
								{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
									<Select.Option key={key} value={value}>
										{label}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>

					<Col xs={24} md={6}>
						<InputLabel label={constantFormValues?.paymentModality?.label} head={true} />
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name={`${constantFormValues?.paymentModality?.key}`}>
							<Select
								disabled
								showSearch
								filterOption={true}
								optionFilterProp="children"
								placeholder="Select from the list"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							>
								{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
									<Select.Option key={key} value={value}>
										{label}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={9}>
						<Form.Item name={`${constantFormValues?.paymentModality?.key}_new`}>
							<Select
								disabled
								showSearch
								filterOption={true}
								optionFilterProp="children"
								placeholder="Select from the list"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							>
								{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
									<Select.Option key={key} value={value}>
										{label}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>

					<Col xs={24} md={6}>
						<InputLabel label="Change Lease Term" head={true} />
					</Col>
					<Col xs={24} md={9}>
						<Form.Item style={{ margin: 0 }} name="inputChangeLeaseTerm">
							<Input
								disabled
								type="number"
								style={{
									marginBottom: 0,
								}}
							/>
						</Form.Item>
					</Col>
					<Col xs={24} md={9}>
						<Form.Item style={{ margin: 0 }} name="inputChangeLeaseTerm_new">
							<Input
								disabled
								type="number"
								style={{
									marginBottom: 0,
								}}
							/>
						</Form.Item>
					</Col>

					{detailType === 'edit' && (
						<>
							<Col xs={24} md={6}>
								<InputLabel label={constantFormValues?.upfrontLeasePayment?.label} head={true} />
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={constantFormValues?.upfrontLeasePayment?.key}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={`${constantFormValues?.upfrontLeasePayment?.key}_new`}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={6}>
								<InputLabel label={constantFormValues?.initialDirectCost?.label} head={true} />
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={constantFormValues?.initialDirectCost?.key}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={`${constantFormValues?.initialDirectCost?.key}_new`}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={6}>
								<InputLabel label={constantFormValues?.securityDeposit?.label} head={true} />
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={constantFormValues?.securityDeposit?.key}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={`${constantFormValues?.securityDeposit?.key}_new`}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={6}>
								<InputLabel label={constantFormValues?.cashIncentiveAmount?.label} head={true} />
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={constantFormValues?.cashIncentiveAmount?.key}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										fixedDecimalScale
										placeholder="0.00"
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name={`${constantFormValues?.cashIncentiveAmount?.key}_new`}>
									<NumericFormat
										disabled
										size="large"
										decimalScale={2}
										fixedDecimalScale
										placeholder="0.00"
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>
						</>
					)}

					<Col xs={24} md={6}>
						<InputLabel label="Payment Schedule" head={true} />
					</Col>
					<Col xs={24} md={9}>
						<Form.List name={'grossRentList'}>
							{(fields) => (
								<>
									<TableContainer
										className="gross-rent-table"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th, & td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},

											'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
											'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
											'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

											'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },

											'& table': { width: '100%', mb: '20px' },
										}}
									>
										<Table aria-label="Gross Rent table">
											<TableHead>
												<TableRow>
													<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
													<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
													<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
												</TableRow>
											</TableHead>

											<TableBody>
												{fields.length > 0 ? (
													fields.map((field, index) => (
														<TableRow key={field.key}>
															<TableCell>
																<Form.Item name={[field.name, 'from']}>
																	<Input
																		disabled
																		style={{
																			width: '100%',
																			padding: '8px',
																			textAlign: 'center',
																			backgroundColor: '#f5f5f5',
																		}}
																	/>
																</Form.Item>
															</TableCell>

															<TableCell>
																<Form.Item name={[field.name, 'to']}>
																	<Input
																		disabled
																		type="number"
																		placeholder="Enter To value"
																		style={{
																			width: '100%',
																			padding: '8px',

																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>
															<TableCell>
																<Form.Item name={[field.name, 'amount']}>
																	<NumericFormat
																		disabled
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		customInput={Input}
																		thousandSeparator=","
																		isAllowed={withValueCap}
																		style={{
																			height: '32px',
																			padding: '18px',
																			fontSize: '13px',
																			textAlign: 'right',
																			borderRadius: '4px',
																		}}
																	/>
																</Form.Item>
															</TableCell>
														</TableRow>
													))
												) : (
													<TableRow>
														<TableCell colSpan={5} style={{ textAlign: 'center' }}>
															No data. Click plus icon in action column to add new entries.
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</>
							)}
						</Form.List>
					</Col>

					<Col xs={24} md={9}>
						<Form.List name={'grossRentList_new'}>
							{(fields) => (
								<>
									<TableContainer
										className="gross-rent-table"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th, & td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},

											'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
											'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
											'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

											'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },

											'& table': { width: '100%', mb: '20px' },
										}}
									>
										<Table aria-label="Gross Rent table">
											<TableHead>
												<TableRow>
													<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
													<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
													<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
												</TableRow>
											</TableHead>

											<TableBody>
												{fields.length > 0 ? (
													fields.map((field, index) => (
														<TableRow key={field.key}>
															<TableCell>
																<Form.Item name={[field.name, 'from']}>
																	<Input
																		disabled
																		style={{
																			width: '100%',
																			padding: '8px',
																			textAlign: 'center',
																			backgroundColor: '#f5f5f5',
																		}}
																	/>
																</Form.Item>
															</TableCell>

															<TableCell>
																<Form.Item name={[field.name, 'to']}>
																	<Input
																		disabled
																		type="number"
																		placeholder="Enter To value"
																		style={{
																			width: '100%',
																			padding: '8px',

																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>
															<TableCell>
																<Form.Item name={[field.name, 'amount']}>
																	<NumericFormat
																		disabled
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		customInput={Input}
																		thousandSeparator=","
																		isAllowed={withValueCap}
																		style={{
																			height: '32px',
																			padding: '18px',
																			fontSize: '13px',
																			textAlign: 'right',
																			borderRadius: '4px',
																		}}
																	/>
																</Form.Item>
															</TableCell>
														</TableRow>
													))
												) : (
													<TableRow>
														<TableCell colSpan={5} style={{ textAlign: 'center' }}>
															No data. Click plus icon in action column to add new entries.
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</>
							)}
						</Form.List>
					</Col>

					{/* <Col xs={24} md={12}>
						<CardAccordion
							sx={{ mb: 2 }}
							darkTitle={false}
							title="Lease Payment Schedule"
							typographySX={{ fontSize: '16px !important' }}
							contentSX={{ p: '10px', pb: '10px !important' }}
							customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
						>
							<>
								<Form.List name={'grossRentList'}>
									{(fields) => (
										<>
											<TableContainer
												className="gross-rent-table"
												sx={{
													'& table, & th, & td': {
														border: '1px solid #e0e0e0',
														borderCollapse: 'collapse',
													},
													'& th, & td': {
														p: '5px',
													},
													'& td .ant-form-item': {
														marginBottom: '0px',
													},

													'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
													'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
													'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

													'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },

													'& table': { width: '100%' },
												}}
											>
												<Table aria-label="Gross Rent table">
													<TableHead>
														<TableRow>
															<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
															<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
															<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
														</TableRow>
													</TableHead>

													<TableBody>
														{fields.length > 0 ? (
															fields.map((field, index) => (
																<TableRow key={field.key}>
																	<TableCell>
																		<Form.Item name={[field.name, 'from']}>
																			<Input
																				disabled
																				style={{
																					width: '100%',
																					padding: '8px',
																					textAlign: 'center',
																					backgroundColor: '#f5f5f5',
																				}}
																			/>
																		</Form.Item>
																	</TableCell>

																	<TableCell>
																		<Form.Item name={[field.name, 'to']}>
																			<Input
																				disabled
																				type="number"
																				placeholder="Enter To value"
																				style={{
																					width: '100%',
																					padding: '8px',

																					textAlign: 'center',
																				}}
																			/>
																		</Form.Item>
																	</TableCell>
																	<TableCell>
																		<Form.Item name={[field.name, 'amount']}>
																			<NumericFormat
																				disabled
																				size="small"
																				decimalScale={2}
																				placeholder="0.00"
																				fixedDecimalScale
																				customInput={Input}
																				thousandSeparator=","
																				isAllowed={withValueCap}
																				style={{
																					height: '32px',
																					padding: '18px',
																					fontSize: '13px',
																					textAlign: 'right',
																					borderRadius: '4px',
																				}}
																			/>
																		</Form.Item>
																	</TableCell>
																</TableRow>
															))
														) : (
															<TableRow>
																<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																	No data. Click plus icon in action column to add new entries.
																</TableCell>
															</TableRow>
														)}
													</TableBody>
												</Table>
											</TableContainer>
										</>
									)}
								</Form.List>
							</>
						</CardAccordion>
					</Col>

					<Col xs={24} md={12}>
						<CardAccordion
							sx={{ mb: 2 }}
							darkTitle={false}
							title="Lease Payment Schedule"
							typographySX={{ fontSize: '16px !important' }}
							contentSX={{ p: '10px', pb: '10px !important' }}
							customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
						>
							<>
								<Form.List name={'grossRentList_new'}>
									{(fields) => (
										<>
											<TableContainer
												className="gross-rent-table"
												sx={{
													'& table, & th, & td': {
														border: '1px solid #e0e0e0',
														borderCollapse: 'collapse',
													},
													'& th, & td': {
														p: '5px',
													},
													'& td .ant-form-item': {
														marginBottom: '0px',
													},

													'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
													'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
													'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

													'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },

													'& table': { width: '100%' },
												}}
											>
												<Table aria-label="Gross Rent table">
													<TableHead>
														<TableRow>
															<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
															<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
															<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
														</TableRow>
													</TableHead>

													<TableBody>
														{fields.length > 0 ? (
															fields.map((field, index) => (
																<TableRow key={field.key}>
																	<TableCell>
																		<Form.Item name={[field.name, 'from']}>
																			<Input
																				disabled
																				style={{
																					width: '100%',
																					padding: '8px',
																					textAlign: 'center',
																					backgroundColor: '#f5f5f5',
																				}}
																			/>
																		</Form.Item>
																	</TableCell>

																	<TableCell>
																		<Form.Item name={[field.name, 'to']}>
																			<Input
																				disabled
																				type="number"
																				placeholder="Enter To value"
																				style={{
																					width: '100%',
																					padding: '8px',

																					textAlign: 'center',
																				}}
																			/>
																		</Form.Item>
																	</TableCell>
																	<TableCell>
																		<Form.Item name={[field.name, 'amount']}>
																			<NumericFormat
																				disabled
																				size="small"
																				decimalScale={2}
																				placeholder="0.00"
																				fixedDecimalScale
																				customInput={Input}
																				thousandSeparator=","
																				isAllowed={withValueCap}
																				style={{
																					height: '32px',
																					padding: '18px',
																					fontSize: '13px',
																					textAlign: 'right',
																					borderRadius: '4px',
																				}}
																			/>
																		</Form.Item>
																	</TableCell>
																</TableRow>
															))
														) : (
															<TableRow>
																<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																	No data. Click plus icon in action column to add new entries.
																</TableCell>
															</TableRow>
														)}
													</TableBody>
												</Table>
											</TableContainer>
										</>
									)}
								</Form.List>
							</>
						</CardAccordion>
					</Col> */}

					{detailType === 'edit' && (
						<>
							<Col xs={24} md={6}>
								<InputLabel label="Advance Payment" head={true} />
							</Col>
							<Col xs={24} md={9}>
								<Form.List name={'advanceAmountList'}>
									{(fields) => {
										return (
											<>
												<TableContainer
													className="gross-rent-table"
													sx={{
														'& table, & th, & td': {
															border: '1px solid #e0e0e0',
															borderCollapse: 'collapse',
														},
														'& th, & td': {
															p: '5px',
														},
														'& td .ant-form-item': {
															marginBottom: '0px',
														},

														'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' } /* From/From Month */,
														'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' } /* To/To Month */,
														'& th:nth-of-type(3), & td:nth-of-type(3)': {
															width: '30%',
														} /* Amount/Monthly Adjustment */,
														'& table': { width: '100%', mb: '20px' } /* Ensure table takes full container width */,
													}}
												>
													<Table aria-label="Gross Rent table">
														<TableHead>
															<TableRow>
																<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
																<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
																<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{fields.length > 0 ? (
																fields.map((field, index) => (
																	<TableRow key={field.key}>
																		<TableCell>
																			<Form.Item name={[field.name, 'from']}>
																				<Input
																					disabled={true}
																					style={{
																						padding: '8px',
																						width: '100%',
																						backgroundColor: '#f5f5f5',
																						textAlign: 'center',
																					}}
																				/>
																			</Form.Item>
																		</TableCell>

																		<TableCell>
																			<Form.Item name={[field.name, 'to']}>
																				<Input
																					disabled
																					type="number"
																					placeholder="Enter To value"
																					style={{
																						padding: '8px',
																						width: '100%',

																						textAlign: 'center',
																					}}
																				/>
																			</Form.Item>
																		</TableCell>

																		<TableCell>
																			<Form.Item name={[field.name, 'amount']}>
																				<NumericFormat
																					disabled
																					size="small"
																					decimalScale={2}
																					placeholder="0.00"
																					fixedDecimalScale
																					customInput={Input}
																					thousandSeparator=","
																					isAllowed={withValueCap}
																					style={{
																						padding: '18px',
																						textAlign: 'right',
																						height: '32px',
																						borderRadius: '4px',
																						fontSize: '13px',
																					}}
																				/>
																			</Form.Item>
																		</TableCell>
																	</TableRow>
																))
															) : (
																<TableRow>
																	<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																		No data. Click the plus icon to add new entries.
																	</TableCell>
																</TableRow>
															)}
														</TableBody>

														<TableFooter>
															<TableRow sx={{ height: 24 }}>
																<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
																	<InputLabel
																		label={'Advance Payment'}
																		head={true}
																		sx={{
																			justifyContent: 'end',
																			marginBottom: '0px',
																		}}
																	/>
																</TableCell>

																<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
																	<NumericFormat
																		disabled
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		customInput={Input}
																		thousandSeparator=","
																		value={advanceAmount || 0}
																		isAllowed={withValueCap}
																		style={{
																			padding: '18px',
																			textAlign: 'right',
																			height: '32px',
																			borderRadius: '4px',
																			fontSize: '13px',
																		}}
																	/>
																</TableCell>
															</TableRow>
														</TableFooter>
													</Table>
												</TableContainer>
											</>
										);
									}}
								</Form.List>
							</Col>

							<Col xs={24} md={9}>
								<Form.List name={'advanceAmountList_new'}>
									{(fields) => {
										return (
											<>
												<TableContainer
													className="gross-rent-table"
													sx={{
														'& table, & th, & td': {
															border: '1px solid #e0e0e0',
															borderCollapse: 'collapse',
														},
														'& th, & td': {
															p: '5px',
														},
														'& td .ant-form-item': {
															marginBottom: '0px',
														},

														'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' } /* From/From Month */,
														'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' } /* To/To Month */,
														'& th:nth-of-type(3), & td:nth-of-type(3)': {
															width: '30%',
														} /* Amount/Monthly Adjustment */,
														'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' } /* Remarks/Total Amount */,
														'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '10%' } /* Action */,
														'& table': { width: '100%', mb: '20px' } /* Ensure table takes full container width */,
													}}
												>
													<Table aria-label="Gross Rent table">
														<TableHead>
															<TableRow>
																<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
																<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
																<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{fields.length > 0 ? (
																fields.map((field, index) => (
																	<TableRow key={field.key}>
																		<TableCell>
																			<Form.Item name={[field.name, 'from']}>
																				<Input
																					disabled={true}
																					style={{
																						padding: '8px',
																						width: '100%',
																						backgroundColor: '#f5f5f5',
																						textAlign: 'center',
																					}}
																				/>
																			</Form.Item>
																		</TableCell>

																		<TableCell>
																			<Form.Item name={[field.name, 'to']}>
																				<Input
																					disabled
																					type="number"
																					placeholder="Enter To value"
																					style={{
																						padding: '8px',
																						width: '100%',

																						textAlign: 'center',
																					}}
																				/>
																			</Form.Item>
																		</TableCell>

																		<TableCell>
																			<Form.Item name={[field.name, 'amount']}>
																				<NumericFormat
																					disabled
																					size="small"
																					decimalScale={2}
																					placeholder="0.00"
																					fixedDecimalScale
																					customInput={Input}
																					thousandSeparator=","
																					isAllowed={withValueCap}
																					style={{
																						padding: '18px',
																						textAlign: 'right',
																						height: '32px',
																						borderRadius: '4px',
																						fontSize: '13px',
																					}}
																				/>
																			</Form.Item>
																		</TableCell>
																	</TableRow>
																))
															) : (
																<TableRow>
																	<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																		No data. Click the plus icon to add new entries.
																	</TableCell>
																</TableRow>
															)}
														</TableBody>

														<TableFooter>
															<TableRow sx={{ height: 24 }}>
																<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
																	<InputLabel
																		head={true}
																		label={'Advance Payment'}
																		sx={{
																			justifyContent: 'end',
																			marginBottom: '0px',
																		}}
																	/>
																</TableCell>

																<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
																	<NumericFormat
																		disabled
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		customInput={Input}
																		thousandSeparator=","
																		isAllowed={withValueCap}
																		value={advanceAmount_new || 0}
																		style={{
																			padding: '18px',
																			textAlign: 'right',
																			height: '32px',
																			borderRadius: '4px',
																			fontSize: '13px',
																		}}
																	/>
																</TableCell>
															</TableRow>
														</TableFooter>
													</Table>
												</TableContainer>
											</>
										);
									}}
								</Form.List>
							</Col>

							{/* <Col xs={24} md={12}>
								<CardAccordion
									sx={{ mb: 2 }}
									darkTitle={false}
									title="Advance Payment & Adjustment"
									typographySX={{ fontSize: '16px !important' }}
									contentSX={{ p: '10px', pb: '10px !important' }}
									customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
								>
									<Form.List name={'advanceAmountList'}>
										{(fields) => {
											return (
												<>
													<TableContainer
														className="gross-rent-table"
														sx={{
															'& table, & th, & td': {
																border: '1px solid #e0e0e0',
																borderCollapse: 'collapse',
															},
															'& th, & td': {
																p: '5px',
															},
															'& td .ant-form-item': {
																marginBottom: '0px',
															},

															'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
															'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
															'& th:nth-of-type(3), & td:nth-of-type(3)': {
																width: '30%',
															},
															'& table': { width: '100%' },
														}}
													>
														<Table aria-label="Gross Rent table">
															<TableHead>
																<TableRow>
																	<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
																	<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
																	<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
																</TableRow>
															</TableHead>
															<TableBody>
																{fields.length > 0 ? (
																	fields.map((field, index) => (
																		<TableRow key={field.key}>
																			<TableCell>
																				<Form.Item name={[field.name, 'from']}>
																					<Input
																						disabled={true}
																						style={{
																							padding: '8px',
																							width: '100%',
																							backgroundColor: '#f5f5f5',
																							textAlign: 'center',
																						}}
																					/>
																				</Form.Item>
																			</TableCell>

																			<TableCell>
																				<Form.Item name={[field.name, 'to']}>
																					<Input
																						disabled
																						type="number"
																						placeholder="Enter To value"
																						style={{
																							padding: '8px',
																							width: '100%',

																							textAlign: 'center',
																						}}
																					/>
																				</Form.Item>
																			</TableCell>

																			<TableCell>
																				<Form.Item name={[field.name, 'amount']}>
																					<NumericFormat
																						disabled
																						size="small"
																						decimalScale={2}
																						placeholder="0.00"
																						fixedDecimalScale
																						customInput={Input}
																						thousandSeparator=","
																						isAllowed={withValueCap}
																						style={{
																							padding: '18px',
																							textAlign: 'right',
																							height: '32px',
																							borderRadius: '4px',
																							fontSize: '13px',
																						}}
																					/>
																				</Form.Item>
																			</TableCell>
																		</TableRow>
																	))
																) : (
																	<TableRow>
																		<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																			No data. Click the plus icon to add new entries.
																		</TableCell>
																	</TableRow>
																)}
															</TableBody>

															<TableFooter>
																<TableRow sx={{ height: 24 }}>
																	<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
																		<InputLabel
																			label={'Advance Payment'}
																			head={true}
																			sx={{
																				justifyContent: 'end',
																				marginBottom: '0px',
																			}}
																		/>
																	</TableCell>

																	<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
																		<NumericFormat
																			disabled
																			size="small"
																			decimalScale={2}
																			placeholder="0.00"
																			fixedDecimalScale
																			customInput={Input}
																			thousandSeparator=","
																			value={advanceAmount || 0}
																			isAllowed={withValueCap}
																			style={{
																				padding: '18px',
																				textAlign: 'right',
																				height: '32px',
																				borderRadius: '4px',
																				fontSize: '13px',
																			}}
																		/>
																	</TableCell>
																</TableRow>
															</TableFooter>
														</Table>
													</TableContainer>
												</>
											);
										}}
									</Form.List>
								</CardAccordion>
							</Col> */}

							{/* <Col xs={24} md={12}>
								<CardAccordion
									sx={{ mb: 2 }}
									darkTitle={false}
									title="Advance Payment & Adjustment"
									typographySX={{ fontSize: '16px !important' }}
									contentSX={{ p: '10px', pb: '10px !important' }}
									customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
								>
									<Form.List name={'advanceAmountList_new'}>
										{(fields) => {
											return (
												<>
													<TableContainer
														className="gross-rent-table"
														sx={{
															'& table, & th, & td': {
																border: '1px solid #e0e0e0',
																borderCollapse: 'collapse',
															},
															'& th, & td': {
																p: '5px',
															},
															'& td .ant-form-item': {
																marginBottom: '0px',
															},

															'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
															'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
															'& th:nth-of-type(3), & td:nth-of-type(3)': {
																width: '30%',
															},
															'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },
															'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '10%' },
															'& table': { width: '100%' },
														}}
													>
														<Table aria-label="Gross Rent table">
															<TableHead>
																<TableRow>
																	<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
																	<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
																	<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
																</TableRow>
															</TableHead>
															<TableBody>
																{fields.length > 0 ? (
																	fields.map((field, index) => (
																		<TableRow key={field.key}>
																			<TableCell>
																				<Form.Item name={[field.name, 'from']}>
																					<Input
																						disabled={true}
																						style={{
																							padding: '8px',
																							width: '100%',
																							backgroundColor: '#f5f5f5',
																							textAlign: 'center',
																						}}
																					/>
																				</Form.Item>
																			</TableCell>

																			<TableCell>
																				<Form.Item name={[field.name, 'to']}>
																					<Input
																						disabled
																						type="number"
																						placeholder="Enter To value"
																						style={{
																							padding: '8px',
																							width: '100%',

																							textAlign: 'center',
																						}}
																					/>
																				</Form.Item>
																			</TableCell>

																			<TableCell>
																				<Form.Item name={[field.name, 'amount']}>
																					<NumericFormat
																						disabled
																						size="small"
																						decimalScale={2}
																						placeholder="0.00"
																						fixedDecimalScale
																						customInput={Input}
																						thousandSeparator=","
																						isAllowed={withValueCap}
																						style={{
																							padding: '18px',
																							textAlign: 'right',
																							height: '32px',
																							borderRadius: '4px',
																							fontSize: '13px',
																						}}
																					/>
																				</Form.Item>
																			</TableCell>
																		</TableRow>
																	))
																) : (
																	<TableRow>
																		<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																			No data. Click the plus icon to add new entries.
																		</TableCell>
																	</TableRow>
																)}
															</TableBody>

															<TableFooter>
																<TableRow sx={{ height: 24 }}>
																	<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
																		<InputLabel
																			head={true}
																			label={'Advance Payment'}
																			sx={{
																				justifyContent: 'end',
																				marginBottom: '0px',
																			}}
																		/>
																	</TableCell>

																	<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
																		<NumericFormat
																			disabled
																			size="small"
																			decimalScale={2}
																			placeholder="0.00"
																			fixedDecimalScale
																			customInput={Input}
																			thousandSeparator=","
																			isAllowed={withValueCap}
																			value={advanceAmount_new || 0}
																			style={{
																				padding: '18px',
																				textAlign: 'right',
																				height: '32px',
																				borderRadius: '4px',
																				fontSize: '13px',
																			}}
																		/>
																	</TableCell>
																</TableRow>
															</TableFooter>
														</Table>
													</TableContainer>
												</>
											);
										}}
									</Form.List>
								</CardAccordion>
							</Col> */}
						</>
					)}
				</Row>
			</Form>
		</HistoryModalContainer>
	);
};

export default LeaseHistoryDetailModal;
